import React from "react";

const renderAsHTML = (control, rawHTML) =>
  React.createElement(control, { dangerouslySetInnerHTML: { __html: rawHTML } });

const decodeHtmlContent = htmlText => {
  let inputControl = document.createElement("textarea");
  // eslint-disable-next-line no-unsanitized/property
  inputControl.innerHTML = htmlText;
  return inputControl.value;
};

const renderVideoOnNewWindow = videoUrl => {
  window.open(videoUrl, "newwindow", "width=800,height=600,left=300");
};

const renderVideo = video => {
  return (
    <iframe
      className="video-frame"
      title={video.title}
      src={video.url}
      webkitAllowFullScreen
      mozallowFullScreen
      allowFullScreen
    />
  );
};

const  hexToRgb = (hex, pen) =>{
  // Remove the # character from the beginning of the hex color
  hex = hex.replace("#", "");

  // Parse the hex color into its red, green, and blue components
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // // Calculate the percentage values of each color component
  const rPercentage = Math.round((r / 255) * 100);
  const gPercentage = Math.round((g / 255) * 100);
  const bPercentage = Math.round((b / 255) * 100);

  // Return the RGB color with percentage values
  return `rgb(${rPercentage}%, ${gPercentage}%, ${bPercentage}%, ${pen}%)`;
}

export { renderAsHTML, decodeHtmlContent, renderVideo, renderVideoOnNewWindow ,hexToRgb};




// WEBPACK FOOTER //
// ./utils/html.js